import { createStore } from "vuex";
import shop from "./modules/shop";

export const mutationTypes = {
  SET_SPINNER: "SET_SPINNER",
  SET_PLATFORM: "SET_PLATFORM",
};

export default createStore({
  state: {
    isShowSpinner: false,
    platform: null,
  },
  getters: {
    isShowSpinner: (state) => state.isShowSpinner,
    platform: (state) => state.platform,
    isMobilePlatform: (state) =>
      state.platform === "android" ||
      state.platform === "ios" ||
      (state.platform === "unknown" &&
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)),
  },
  mutations: {
    [mutationTypes.SET_SPINNER](state, payload) {
      state.isShowSpinner = payload;
    },
    [mutationTypes.SET_PLATFORM](state, payload) {
      state.platform = payload;
    },
  },
  modules: {
    shop,
  },
});
